export default "__VITE_ASSET__3kXB8OEu__"